import React, { useState } from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';

const ContactUsPage = () => {
  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [subject, setSubject] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  return (
    <Layout>
      <article>
        <h2>Зворотній зв&apos;язок</h2>

        <form
          action="https://getform.io/f/22bcd2c5-78d7-45c3-b0fd-a44fb6721db8"
          method="POST"
          className="top-spacing-big contact-us-form">
          <label htmlFor="name" className="contact-us-label">
            Ваше ім&apos;я:
          </label>
          <input
            id="name"
            name="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="contact-us-input"
          />
          <label htmlFor="email" className="contact-us-label">
            Адрес вашої електронної пошти:
          </label>
          <input
            id="email"
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="contact-us-input"
          />
          <label htmlFor="subject" className="contact-us-label">
            Тема:
          </label>
          <input
            id="subject"
            name="subject"
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="contact-us-input"
          />
          <input type="hidden" name="_gotcha" className="hidden" />
          <label htmlFor="message" className="contact-us-label">
            Ваше повідомлення:
          </label>
          <textarea
            id="message"
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="contact-us-textarea"
          />
          <button type="submit" className="contact-us-submit">
            Надіслати
          </button>
        </form>
      </article>
    </Layout>
  );
};

export default ContactUsPage;

export const Head = () => <SEO title="Зворотній зв'язок" />;
